export default "__VITE_ASSET__BItyVY$Z__"